import { Button, Heading, IconButton } from '@assembly-js/design-system';

import { ToolbarDivider } from 'src/components/ToolbarDivider';

interface AppSettingsModalHeaderProps {
  onClose: () => void;
  onSave: () => void;
  appName: string;
  dirty: boolean;
  isSaving: boolean;
}

export const AppSettingsModalHeader: React.FC<AppSettingsModalHeaderProps> = ({
  onClose,
  onSave,
  appName,
  dirty,
  isSaving,
}) => {
  return (
    <div className="flex h-15 shrink-0 items-center justify-between border-b border-x-0 border-t-0 border-solid border-non-hover-border bg-white px-4 py-4 sm:px-6">
      <div className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden pr-4 sm:gap-3">
        <IconButton
          icon="Close"
          onClick={onClose}
          label="Close"
          variant="minimal"
          className="text-black-heading"
          size="sm"
        />
        <ToolbarDivider />
        <Heading className="min-w-0 truncate text-sm text-black-heading sm:text-lg">
          {appName}
        </Heading>
      </div>

      <div className="flex shrink-0 items-center gap-2.5">
        <Button
          label="Save changes"
          variant="primary"
          onClick={onSave}
          loading={isSaving}
          disabled={!dirty || isSaving}
          size="sm"
          type="submit"
        />
      </div>
    </div>
  );
};
